function spanWidth(param) {
    let { columns, span } = param;
    const start = columns.findIndex((column)=>column.id === span.from);
    const declaredEnd = span.to == null ? start : columns.findIndex((column)=>column.id === span.to);
    const end = Math.max(start, declaredEnd);
    return {
        start,
        end,
        width: columns.slice(start, end + 1).reduce((sum, column)=>sum + column.width, 0)
    };
}
function toCell(value, width) {
    return {
        width,
        text: value.text,
        caption: 'caption' in value ? value.caption : undefined,
        info: 'info' in value ? value.info : undefined
    };
}
export function summaryCells(param) {
    let { columns, summary } = param;
    const label = spanWidth({
        columns,
        span: summary.label
    });
    const amount = spanWidth({
        columns,
        span: summary.amount
    });
    return {
        offset: columns.slice(0, label.start).reduce((sum, column)=>sum + column.width, 0),
        label: toCell(summary.label, label.width),
        gap: columns.slice(label.end + 1, amount.start).reduce((sum, column)=>sum + column.width, 0),
        amount: toCell(summary.amount, amount.width)
    };
}
